export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/speedcarBlackIcon.8f221b34.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};